/* eslint-disable import/prefer-default-export */
import React from 'react'
import PropTypes from 'prop-types'

const HelpIcon = ({ width, height, title }) => (
  <svg width={width} height={height} viewBox="0 0 23 30" fill="currentColor">
    <title>{title}</title>
    <path d="M10.6 3.5q4.8 0 8.2 3.4t3.4 8.2q0 4.8-3.4 8.2t-8.2 3.4-8.2-3.4-3.4-8.2 3.4-8.2 8.2-3.4zm0 20.3q.8 0 1.4-.6t.6-1.4-.6-1.4-1.4-.6-1.4.6-.6 1.4.6 1.4 1.4.6zm1.5-6.8q0-.4.4-.7t1-.7 1.1-.8 1-1.3.4-1.9q0-2.1-1.5-3.5t-3.8-1.4q-1.3 0-2.5.6T6.4 8.5l-.6.6L7.7 11l.4-.4q.2-.2 1.1-.6t1.4-.4q1.1 0 1.7.6t.7 1.3q0 .6-.6 1.2t-1.3.9-1.3 1.1-.6 1.7v1h2.9v-.5z" />
  </svg>
)

HelpIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string,
}

HelpIcon.defaultProps = {
  width: 20,
  height: 20,
  title: 'Help',
}

export default HelpIcon
